var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{attrs:{"type":"button","secondary":"","outline":"","small":"","disabled":_vm.pending},on:{"click":_vm.execute}},[_vm._v(" Cancel Syncronization "),(_vm.pending)?_c('Loader',{attrs:{"small":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }